import { Box, Tooltip, IconButton, Divider } from '@mui/material';
import DatePickerBR from './DatePickerBR';

const PublishedAtFilter = ({
  publishedAtFrom,
  setPublishedAtFrom,
  publishedAtTo,
  setPublishedAtTo,
  publishedAtMonth,
  setPublishedAtMonth,
  publishedAtYear,
  setPublishedAtYear,
  onClear,
  startYear,
  yearsBack = 10,
}) => {
  const isIntervalActive = !!publishedAtFrom || !!publishedAtTo;

  const getYearOptions = () => {
    const current = new Date().getFullYear();
    const start = 2022;
    const arr = [];
    for (let y = current; y >= start; y--) arr.push(String(y));
    return arr;
  };

  const onChangeFrom = v => {
    if (v && (publishedAtYear || publishedAtMonth)) {
      setPublishedAtYear('');
      setPublishedAtMonth('');
    }
    setPublishedAtFrom(v);
  };

  const onChangeTo = v => {
    if (v && (publishedAtYear || publishedAtMonth)) {
      setPublishedAtYear('');
      setPublishedAtMonth('');
    }
    setPublishedAtTo(v);
  };

  const onChangeMonth = v => {
    if (v && (publishedAtFrom || publishedAtTo)) {
      setPublishedAtFrom('');
      setPublishedAtTo('');
    }
    setPublishedAtMonth(v);
  };

  const onChangeYear = v => {
    if (v && (publishedAtFrom || publishedAtTo)) {
      setPublishedAtFrom('');
      setPublishedAtTo('');
    }
    setPublishedAtYear(v);
  };

  return (
    <div style={{ width: '100%', marginBottom: 8 }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          p: 1.5,
          border: '1px solid #D7E8F7',
          borderRadius: 1.5,
          background: '#F8FBFF',
          flexWrap: 'wrap',
        }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <label style={{ fontSize: 12, color: '#405A6D' }}>Publicado de</label>
          <DatePickerBR
            valueISO={publishedAtFrom}
            onChangeISO={iso => onChangeFrom(iso)}
          />

          <label style={{ fontSize: 12, color: '#405A6D' }}>
            Publicado até
          </label>
          <DatePickerBR
            valueISO={publishedAtTo}
            onChangeISO={iso => onChangeTo(iso)}
          />
        </Box>

        <Divider
          flexItem
          orientation="vertical"
          sx={{ borderColor: '#D7E8F7' }}
        />

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <span style={{ fontSize: 12, color: '#405A6D' }}>Ou</span>

          <label style={{ fontSize: 12, color: '#405A6D' }}>Mês</label>
          <select
            value={publishedAtMonth}
            onChange={e => onChangeMonth(e.target.value)}
            style={{
              height: 36,
              padding: '6px 10px',
              border: '1px solid #D7E8F7',
              borderRadius: 8,
              background: '#FFF',
              outline: 'none',
              minWidth: 80,
            }}
            disabled={isIntervalActive}>
            <option value="">-</option>
            {[...Array(12)].map((_, i) => (
              <option key={i + 1} value={String(i + 1).padStart(2, '0')}>
                {i + 1}
              </option>
            ))}
          </select>

          <label style={{ fontSize: 12, color: '#405A6D' }}>Ano</label>
          <select
            value={publishedAtYear}
            onChange={e => onChangeYear(e.target.value)}
            style={{
              height: 36,
              padding: '6px 10px',
              border: '1px solid #D7E8F7',
              borderRadius: 8,
              background: '#FFF',
              outline: 'none',
              minWidth: 100,
            }}
            disabled={isIntervalActive}>
            <option value="">-</option>
            {getYearOptions().map(y => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </select>
        </Box>

        <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center', gap: 1 }}>
          <Tooltip title="Limpar filtros de data">
            <IconButton
              size="small"
              onClick={onClear}
              sx={{
                border: '1px solid',
                borderColor: 'primary.main',
                backgroundColor: 'background.paper',
                color: 'primary.main',
                borderRadius: 2,
                fontSize: '0.75rem',
              }}>
              Limpar filtros de data
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
    </div>
  );
};

export default PublishedAtFilter;
